import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  hideSnackbar,
  showSnackbar,
  toggleAsanaGuide,
  toggleTrelloGuide,
} from '../modules/App/store/actions';

import Loading from '../components/Loading';

import ErrorPage from '../pages/404';

const withIntegrations = (WrappedComponent) => {
  const Component = (props) => {
    const { app } = useParams();

    const { uid, dispatch } = props;

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(false);

    useEffect(() => {
      switch (app) {
        case 'slack': {
          const code = new URL(window.location.href).searchParams.get('code');

          if (error) {
            setError(true);
            setLoading(false);
            return;
          }

          (async () => {
            try {
              const payload = { code };

              await axios.post(
                `${process.env.REACT_APP_FIREBASE_FUNCTION_HOST}/integrations/slack`,
                {
                  ...payload,
                  uid,
                  redirectURL: `${window.location.origin}/integration/slack`,
                },
              );

              dispatch(showSnackbar('Slack connected successfully.'));
              setTimeout(() => dispatch(hideSnackbar()), 5000);
            } catch (e) {
              setError(true);
            } finally {
              setLoading(false);
            }
          })();
          break;
        }

        case 'trello': {
          const { hash } = window.location;

          if (hash) {
            const { token } = hash
              .substring(1)
              .split('&')
              .reduce(
                (a, c) => ({
                  ...a,
                  [c.split('=')[0]]: decodeURI(c.split('=')[1]),
                }),
                {},
              );

            if (token) {
              (async () => {
                try {
                  await axios.post(
                    `${process.env.REACT_APP_FIREBASE_FUNCTION_HOST}/integrations/trello`,
                    {
                      token,
                      uid,
                    },
                  );

                  dispatch(toggleTrelloGuide(true));
                } catch (e) {
                  setError(true);
                } finally {
                  setLoading(false);
                }
              })();
            } else {
              setLoading(false);
              setError(true);
            }
          } else {
            setLoading(false);
            setError(true);
          }

          break;
        }

        case 'asana': {
          const code = new URL(window.location.href).searchParams.get('code');

          if (error) {
            setError(true);
            setLoading(false);
            return;
          }

          (async () => {
            try {
              const payload = { code };

              await axios.post(
                `${process.env.REACT_APP_FIREBASE_FUNCTION_HOST}/integrations/asana`,
                {
                  ...payload,
                  uid,
                  redirectURL: `${window.location.origin}/integration/asana`,
                },
              );

              dispatch(toggleAsanaGuide(true));

              // dispatch(showSnackbar('Asana connected successfully.'));
              // setTimeout(() => dispatch(hideSnackbar()), 5000);
            } catch (e) {
              setError(true);
            } finally {
              setLoading(false);
            }
          })();
          break;
        }

        default: {
          setLoading(false);
          setError(true);
          break;
        }
      }
    }, [app, uid, error, dispatch]);

    if (loading) {
      return <Loading />;
    }

    if (error) {
      return <ErrorPage errorCode={400} />;
    }

    return <WrappedComponent {...props} />;
  };

  Component.propTypes = {
    uid: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  return Component;
};

const mapStateToProps = ({
  user: {
    user: { uid },
  },
}) => ({ uid });

export default compose(connect(mapStateToProps), withIntegrations);
